(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-competition/assets/javascripts/load-draws-with-numbers.js') >= 0) return;  svs.modules.push('/components/tipsen/route-competition/assets/javascripts/load-draws-with-numbers.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _RTK = RTK,
  unwrapResult = _RTK.unwrapResult;
const logger = svs.core.log.getLogger('tipsen:route-competition');

const loadOpenedDrawsByEngine = svs.components.sport.drawsRedux.actions.loadOpenedDrawsByEngine;

async function loadDrawsWithGivenNumbersAsync(_ref) {
  let drawNumbers = _ref.drawNumbers,
    _productId = _ref.productId,
    allCurrentDraws = _ref.allCurrentDraws,
    currentEngine = _ref.currentEngine,
    dispatch = _ref.dispatch;
  const _currentEngine$drawPr = _slicedToArray(currentEngine.drawProductIds, 1),
    productIdByEngine = _currentEngine$drawPr[0];
  const productId = _productId || productIdByEngine;
  if (!Array.isArray(drawNumbers) || drawNumbers.some(item => typeof item !== 'number')) {
    throw new Error(drawNumbers ? 'Expected drawNumbers to be number[]' : 'Missing drawNumber');
  }
  if (typeof productId !== 'number') {
    throw new Error(productId ? 'Expected productId to be number' : 'Missing productId');
  }
  const _getAlreadyLoadedDrawOrNull = number => Array.isArray(allCurrentDraws) ? allCurrentDraws.find(loadedDraw => (loadedDraw === null || loadedDraw === void 0 ? void 0 : loadedDraw.drawNumber) === number && (loadedDraw === null || loadedDraw === void 0 ? void 0 : loadedDraw.productId) === productId) : null;
  if (drawNumbers.length === 0 || drawNumbers.every(_getAlreadyLoadedDrawOrNull)) {
    return drawNumbers.map(_getAlreadyLoadedDrawOrNull);
  }
  try {
    const results = await dispatch(loadOpenedDrawsByEngine(currentEngine));
    const fetchedDraws = unwrapResult(results).Draws;
    return drawNumbers.map(number => fetchedDraws.entities["".concat(productId, "_").concat(number)] || null);
  } catch (error) {
    if (error.name === 'ConditionError') {
      return drawNumbers.map(_getAlreadyLoadedDrawOrNull);
    }
    logger.warn('loadOpenedDrawsByEngine() failed -', error.message);
    throw error;
  }
}

setGlobal('svs.components.tipsen.routeCompetition', {
  loadDrawsWithGivenNumbersAsync
});

 })(window);